var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"mx-auto mt-10 pa-4 text-center py-10",attrs:{"max-width":"600","rounded":"","elevation":"1"}},[_c('v-icon',{staticClass:"mb-2",attrs:{"size":"50","color":"warning"}},[_vm._v("mdi-alert")]),_c('div',{staticClass:"title"},[_vm._v("Доступ запрещен")]),_c('div',[_vm._v("Обратитесь к администратору или в тех.поддержку")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }